import { useState } from "react";

import { useActive } from "hooks/useActive";
import { useStorage } from "hooks/useStorage";

export function useApplicationShell() {
  const [isOpen, setIsOpen] = useStorage("isSidebarOpen", true);
  const { isActive, toggleActive } = useActive(isOpen);
  const [isSidebarHidden, setIsSidebarHidden] = useState(!isOpen);

  function toggleSidebar() {
    toggleActive();
    setIsOpen(!isOpen);

    if (!isOpen) {
      setIsSidebarHidden(false);
    }
  }

  function handleTransitionEnd() {
    setIsSidebarHidden(!isOpen);
  }

  return {
    isSidebarOpen: isActive,
    toggleSidebar,
    handleTransitionEnd,
    isSidebarHidden,
  };
}
